import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddTaxClass = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr, save, update } = useService("Data", "taxClass");
  const { setTitle } = useService("Meta");
  const { showAlert, generateUID } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [uid, setuid] = useState<string>("");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [className, setclassName] = useState<string>("");
  const [amount, setamount] = useState<string>("");
  const [label, setlabel] = useState<string>("");

  const getTaxClassData = useCallback(
    async (query) => {
      const result = await fetchByAttr(query);
      if (result.status) {
        let taxClassData = result.data[0];
        setmode("edit");
        setclassName(taxClassData.className);
        setamount(taxClassData.amount);
        setlabel(taxClassData.label);
        setuid(query.uid);
      } else showAlert({ type: "error", msg: "No taxClasss added yet!" });
    },
    [fetchByAttr, showAlert]
  );

  const addTaxClass = useCallback(
    async (e) => {
      e.preventDefault();
      let error = false,
        errorMsg = "",
        taxClassObject = {
          className,
          amount,
          label,
          uid: mode === "add" ? generateUID() : uid,
        };
      if (title === "") {
        errorMsg = t("errorMsg.required.title");
        error = true;
      } else if (slug === "") {
        errorMsg = t("errorMsg.required.slug");
        error = true;
      }
      if (!error) {
        if (mode === "add") {
          const result = await save(taxClassObject);
          if (result.status) {
            showAlert({
              type: "success",
              msg: "Tax Class added successfully!",
            });
            navigateTo({ route: "/admin/taxClass/list" });
          } else showAlert({ type: "error", msg: "Unable to add taxClass!" });
        } else {
          let data = {
            query: JSON.stringify({ uid }),
            taxClassData: JSON.stringify(taxClassObject),
          };
          const result = await update(data);
          if (result.status) {
            showAlert({
              type: "success",
              msg: "Tax Class updated successfully!",
            });
            navigateTo({ route: "/admin/taxClass/list" });
          } else
            showAlert({ type: "error", msg: "Unable to update taxClass!" });
        }
      } else showAlert({ type: "error", msg: errorMsg });
    },
    [
      amount,
      className,
      generateUID,
      label,
      mode,
      navigateTo,
      save,
      showAlert,
      slug,
      t,
      title,
      uid,
      update,
    ]
  );

  setTitle(t("addTaxClass"), "admin");
  const urlData = urlToSplitData(getLocationData().pathname);
  const urlMode = urlData[3];
  const urlUid = urlData[4];

  useEffect(() => {
    if (urlMode === "edit") {
      getTaxClassData({ uid: urlUid });
    }
  }, [urlMode, urlUid]);

  return {
    pageTitle: mode + " Tax Class",
    addTaxClass,
    className,
    setclassName,
    amount,
    setamount,
    label,
    setlabel,
  };
};
